import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-forest/20 py-4" data-id="element-194">
      <button onClick={() => setIsOpen(!isOpen)} className="flex w-full justify-between items-center text-left focus:outline-none" data-id="element-195">
        <h4 className="font-serif text-lg md:text-xl font-semibold text-forest-dark pr-4" data-id="element-196">
          {question}
        </h4>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="text-forest flex-shrink-0" data-id="element-197">
          <ChevronDown size={24} data-id="element-198" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-199">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-200">
            <p className="pt-4 text-gray-700 leading-relaxed font-sans" data-id="element-201">
              {answer}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}